import SongDetails from './SongDetails';

export default SongDetails;
